module.exports = __webpack_public_path__ + "img/flower.8b5b7f58.png";